/**
 * Supabase client (для Realtime / liveProvider).
 *
 * Anon key — безопасно для браузера, RLS защищает данные.
 * Используется ТОЛЬКО для подписок на изменения (orders, products, etc.).
 * Все мутации идут через FastAPI (axios) для централизованной валидации.
 */

import { createClient, type SupabaseClient } from "@supabase/supabase-js";

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL ?? "";
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY ?? "";

export const isSupabaseConfigured = Boolean(SUPABASE_URL && SUPABASE_ANON_KEY);

if (!isSupabaseConfigured) {
  // eslint-disable-next-line no-console
  console.warn(
    "[supabase] VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY не заданы — Realtime будет отключён",
  );
}

// createClient() бросает синхронное исключение при пустом URL — вызывать
// его безусловно нельзя: это падает на этапе загрузки модуля, до рендера
// React, и роняет всё приложение белым экраном без единой строчки в Network
// (self-hosted VPS сейчас намеренно собирается с пустыми VITE_SUPABASE_*,
// см. providers/live.ts — там isSupabaseConfigured проверяется ДО любого
// обращения к supabase, так что null здесь абсолютно безопасен).
export const supabase: SupabaseClient | null = isSupabaseConfigured
  ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
      auth: {
        persistSession: false,
        autoRefreshToken: false,
        detectSessionInUrl: false,
      },
      realtime: {
        params: { eventsPerSecond: 10 },
      },
    })
  : null;
